import React, { useEffect, useState } from "react";
import DashboardHeader from "../../components/DashboardHeader";
import { landingPageOptions } from "./landingPageOptions";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { getItem, removeItem } from "../../utils/localStorage";

const Landing = () => {
  const { user } = useAuth();
  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }
  
  return (
    <div className="px-16 py-2">
      <DashboardHeader showLogo />
      <div className="flex flex-wrap gap-24 justify-center mt-20">
        {landingPageOptions.map((option, i) => {
          return (
            <Link key={`landing-option-${i}`} to={option.link}>
              <div className="flex flex-col items-center justify-center cursor-pointer min-w-[17vw] min-h-[17vw] px-4 py-6 bg-white rounded-[1rem]">
                <img
                  src={option.icon}
                  alt={option.title}
                  className={"w-[8vw] mb-2"}
                />
                <div className="font-size-large font-family-medium mt-7">
                  {option.title}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Landing;
